import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import { OrganizationStatisticsEntity } from './types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<OrganizationStatisticsEntity>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminOrganizationStatisticsReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminOrganizationStatistics.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getAdminOrganizationStatistics.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getAdminOrganizationStatistics.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getAdminOrganizationStatistics.reset.type]: actionsHandlers.handleGetOneReset,
});

export default adminOrganizationStatisticsReducer;
